const greenhouse = ($) => {
    const wrapper = $('#grnhse_app');
    const script = document.createElement('script');
    let script_src = 'https://boards.eu.greenhouse.io/embed/job_board/js?for=ans';

    if (!wrapper.length) return;

    const region = wrapper.attr('data-region');

    if (region === 'IN') {
        script_src = 'https://boards.eu.greenhouse.io/embed/job_board/js?for=ans-india';
    }

    script.setAttribute('src', script_src);
    document.body.appendChild(script);
};

export default greenhouse;